import { Component } from '@angular/core'

@Component({
  selector: 'ddc-appstore-btn-small',
  templateUrl: './ddc-appstore-btn-small.component.html',
  styleUrl: './ddc-appstore-btn-small.component.scss',
  imports: [],
})
export class DdcAppstoreBtnSmallComponent {}
